module.exports = __webpack_public_path__ + "img/AVPN-Southeast-Asia-Summit-967x683.e89a9bd4.png";